import React from 'react';
import  ReactDOM from 'react-dom';

class ConfirmModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isOpen: false
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.executeCallback = this.executeCallback.bind(this);
        this.executeCallbackCancel = this.executeCallbackCancel.bind(this);

    }

    componentDidMount() {
        if (this.props.openModal) {
            this.openModal();
        }
    }

    openModal() {
        this.setState({isOpen: true});
        setTimeout(function () {
            this.refs['modal'].classList.add('in');
        }.bind(this), 200);
    }

    closeModal() {
        this.refs['modal'].classList.remove('in');
        setTimeout(function () {
            this.setState({isOpen: false});
            ReactDOM.unmountComponentAtNode(document.getElementById('confirm-modal-overlay'));
        }.bind(this), 200);
    }

    executeCallback() {
        let data = this.props.data;
        if(data.callback) {
            data.callback();
            this.closeModal();
        } else {
            this.closeModal();
        }
    }

    executeCallbackCancel() {
        let data = this.props.data;
        if(data.callbackCancel) {
            data.callbackCancel();
            this.closeModal();
        } else {
            this.closeModal();
        }
    }

    render() {

        if (!this.state.isOpen || !this.props.data) return <div />;
        let data = this.props.data;

        let cancelButton = null;
        if (data.cancelMsg) {
            cancelButton = <button onClick={this.executeCallbackCancel} type="button" className="btn btn-secondary">{data.cancelMsg}</button>;
        };

        return (
            <div ref="modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">{data.title || 'Message:'}</h3>
                            <button onClick={this.closeModal} type="button" className="close" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{data.msg}</p>
                        </div>
                        <div className="modal-footer">
                            { cancelButton }
                            <button onClick={this.executeCallback} type="button" className="btn btn-primary">{data.okMsg || 'OK'}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/js/components/ConfirmModal.react.jsx